import type { AuthorizationSnapshot } from '@delta/domain';
import { hasPermission } from '@delta/auth';

export function hasAnyPermission(
  snapshot: Pick<AuthorizationSnapshot, 'permissions'> | null | undefined,
  permissionCodes: readonly string[],
) {
  return permissionCodes.some((permissionCode) => hasPermission(snapshot, permissionCode));
}
